import { useCallback } from "react";

import type { SiteControllerSettingNeppanInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";

import { SiteControllerSetting_SettingPage_Query } from "../../../../base/repository/query/fetch-site-controller-setting/query";
import { SiteControllerSettingNeppanUpdate_SettingPage_Mutation } from "../schema";

export const useSiteControllerSettingNeppanMutation = () => {
	const { mutationFunc } = useCustomMutation(SiteControllerSettingNeppanUpdate_SettingPage_Mutation);

	const onUpdate = useCallback(
		async ({ input }: { input: SiteControllerSettingNeppanInput }) => {
			return await mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: START_GUIDE_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
					{
						query: SiteControllerSetting_SettingPage_Query,
						variables: {
							hotelID: input.hotelID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	return { onUpdate };
};
